var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { Result, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import EntityFormWrap from "../../../../EntityManager/components/EntityFormWrap";
import EntityDelete from "../../../../EntityManager/components/EntityDelete";
import { Operation } from "../../../../EntityManager";
import styles from "./ManagerDetailsView.module.scss";
function ManagerDetailsView({ entity, entityId, operation, form, formProps, loading, initialLoading, readOnly, renderDeleteQuestion, onEntitySave, onEntityDelete, onCancel, onSaveCompleted, onDeleteCompleted, }) {
    const isReadOnly = !!(entity && readOnly && readOnly(entity));
    const [error, setError] = useState(null);
    const [createKey, setCreateKey] = useState(0);
    const handleFormInput = () => {
        setError(null);
    };
    const handleSave = (formData) => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield onEntitySave(formData, entity || undefined);
            if (result === false) {
                return;
            }
            if (operation === Operation.CREATE) {
                // force reseting form by changing the key, after successful save
                setCreateKey(k => k + 1);
            }
            if (onSaveCompleted) {
                onSaveCompleted();
            }
        }
        catch (err) {
            setError(err.message || "An unexpected error occurred");
        }
    });
    const handleDelete = () => __awaiter(this, void 0, void 0, function* () {
        if (!entity || !onEntityDelete)
            return;
        try {
            yield onEntityDelete(entity);
            if (onDeleteCompleted) {
                onDeleteCompleted();
            }
        }
        catch (err) {
            setError(err.message || "An unexpected error occurred");
        }
    });
    if (initialLoading && !entity && operation !== Operation.CREATE) {
        return (React.createElement("div", { className: styles.detailsViewContainer },
            React.createElement("div", { className: styles.preloaderContainer },
                React.createElement(LoadingOutlined, { className: styles.preloader }))));
    }
    if (!entity && operation !== Operation.CREATE) {
        return (React.createElement("div", { className: styles.detailsViewContainer },
            React.createElement(Result, { status: "404", title: React.createElement(Trans, { i18nKey: "notFound" }), subTitle: React.createElement(Trans, { i18nKey: "entityNotFound" }), extra: React.createElement(Button, { type: "primary", onClick: onCancel },
                    React.createElement(Trans, { i18nKey: "goBack" })) })));
    }
    return (React.createElement("div", { className: styles.detailsViewContainer },
        (operation === Operation.CREATE || (operation === Operation.EDIT && entity)) && (React.createElement(EntityFormWrap, { key: operation === Operation.CREATE ? `create-${createKey}` : `edit-${entityId !== null && entityId !== void 0 ? entityId : ''}`, form: form, additionalProps: formProps, loading: loading, entity: entity || undefined, readOnly: isReadOnly, onSave: handleSave, onCancel: onCancel, onInput: handleFormInput, error: error, saveButtonText: operation === Operation.CREATE ? (React.createElement(Trans, { i18nKey: "create" })) : (React.createElement(Trans, { i18nKey: "save" })) })),
        operation === Operation.DELETE && entity && (React.createElement(EntityDelete, { loading: loading, entity: entity, question: renderDeleteQuestion(entity), onContinue: handleDelete, onCancel: onCancel, error: error }))));
}
export default observer(ManagerDetailsView);
